import ActionType from 'actions/ActionType'

export default (state = {}, action) => {
  switch (action.type) {
    case ActionType.Tasks.SCHEMA_SUCCESS:
      return {
        ...state,
        [action.payload.schemaType]: action.payload.schema,
      }
    default:
      return state
  }
}
